import Wrapper from '../../assets/wrappers/JobInfo';

const BuildingInfo = ({ icon, text, tooltip }) => {
  return (
    <Wrapper>
      <span className='job-icon' title={tooltip}>
        {icon}
      </span>
      <span className='job-text'>{text}</span>
    </Wrapper>
  );
};

export default BuildingInfo;
